import { currencyRateInMxn } from "../../shared/currencyRates";
import React, { useEffect } from "react";
import { Row, Col, Form } from "react-bootstrap";
import useResource from "../../shared/useResource";
import { Field, Status } from "../../shared/UI";
export default function CurrencyFields({ header, onChange, onCurrencyChange, disabled }) {
  const { data, error, loading, reload } = useResource("monedas?limit=100");
  const rows = data?.data || [];
  const mxn = rows.find((m) => m.clave_moneda === "MXN");
  const current = rows.find((m) => String(m.id) === String(header.id_moneda));
  useEffect(() => {
    if (!header.id_moneda && mxn) {
      if (onCurrencyChange) onCurrencyChange(mxn.id, 1);
      else {
        onChange("id_moneda", mxn.id);
        onChange("tipo_cambio", 1);
      }
    }
  }, [header.id_moneda, mxn?.id]); // eslint-disable-line react-hooks/exhaustive-deps
  const change = (id) => {
    const c = rows.find((m) => String(m.id) === id);
    const rate = currencyRateInMxn(id, rows);
    const exchange = c?.clave_moneda === "MXN" ? 1 : rate || "";
    if (onCurrencyChange) onCurrencyChange(id, exchange);
    else {
      onChange("id_moneda", id);
      onChange("tipo_cambio", exchange);
    }
  };
  return (
    <div className="surface mb-3">
      <Status error={error} loading={loading} onRetry={reload} />
      <Row className="g-3">
        <Col md={6}>
          <Form.Label>Moneda</Form.Label>
          <Form.Select
            aria-label="Moneda del documento"
            value={header.id_moneda || ""}
            onChange={(e) => change(e.target.value)}
            disabled={disabled || loading}
          >
            <option value="">Seleccionar moneda</option>
            {rows.map((m) => (
              <option key={m.id} value={m.id}>
                {m.clave_moneda} · {m.descripcion || m.nombre}
              </option>
            ))}
          </Form.Select>
        </Col>
        <Col md={6}>
          <Field
            label="Tipo de cambio"
            type="number"
            step="0.000001"
            min="0.000001"
            value={header.tipo_cambio}
            onChange={(v) => onChange("tipo_cambio", v)}
            disabled={disabled || current?.clave_moneda === "MXN"}
          />
        </Col>
      </Row>
    </div>
  );
}
